export const getAttributeWithValues = (attributes, key) => {
    const attribute = attributes?.find((attr) => attr.key === key);
    return attribute && attribute.values?.length > 0 ? attribute : null;
};
export const getAvailableItems = (items, availabilityKey = "is_available") => {
    if (!Array.isArray(items))
        return [];
    return items.filter((item) => {
        if (!item)
            return false;
        const value = item[availabilityKey];
        if (typeof value === "string") {
            return value.toLowerCase() === "true";
        }
        return Boolean(value);
    });
};
//# sourceMappingURL=detailPageHelpers.js.map